/**
 * TODO This is just a dummy tooltip, needs work
 */
import React, {useState} from "react";

interface Props {
    position?: "bottom" | "top" | "left" | "right" | "top-left" | "top-right";
    text: string;
}

const Tooltip: React.FC<Props> = ({text, position= "top"}) => {
    const [isHovered, setIsHovered] = useState(false)

    const tooltipClass = () => {
        const common = "absolute flex items-center justify-center w-48 p-1 text-gray-600 dark:text-white"
            + "bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-none shadow-gray-200 "
            + "border-solid border-2 border-black dark:border-gray-500";

        switch (position) {
            case "left":
                return `${common} left-12 -top-4`;
            case "right":
                return `${common} -left-[13.2rem] -top-4`;
            case "top":
                return `${common} -translate-x-1/2 -top-16 left-1/2 `;
            case "top-left":
                return `${common} -left-4 -top-16`;
            case "top-right":
                return `${common} -left-[9.5rem] -top-16`;
            default:
                return "";
        }
    };

    const arrowClass = () => {
        const common = "absolute w-6 h-6 transform rotate-45 text-white fill-current dark:text-gray-800";
        switch (position) {
            case "left":
                return `${common} -translate-y-1/2 -left-3 top-1/2`;
            case "right":
                return `${common} -translate-y-1/2 -right-3 top-1/2`;
            case "top":
            case "top-left":
            case "top-right":
                return `${common} -translate-x-1/2 left-1/2 bottom-0.5 -mb-3`;
            default:
                throw new Error("Unsupported value: " + position);
        }
    };

    return (
        <div className="relative inline-block ml-2"
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
        >
            <span
                className="text-gray-600 transition-colors duration-200 focus:outline-hidden dark:text-gray-200 dark:hover:text-blue-400 hover:text-blue-500">
                <svg xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth="2"
                     stroke="currentColor"
                     className="w-4 h-4">
                    <path strokeLinecap="round" strokeLinejoin="round"
                          d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                    />
                </svg>
            </span>
            {isHovered && (
                <div>
                    <p className={tooltipClass()}>
                        <span className="truncate">{text}</span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             className={arrowClass()}
                             stroke="#fff"
                             fill="currentColor"
                             viewBox="0 0 24 24"
                        >
                            <path d="M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"></path>
                        </svg>
                    </p>
                </div>
            )}
        </div>
    );
};

export default Tooltip;